<template>
  <div>
    <!-- 新增、删除按钮及搜索框 -->
    <el-row type="flex" justify="space-between" align="middle" class="tool-tips">
      <el-col align="right">
        <!-- 这里@keyup.enter需要加上native -->
        <el-input
          v-model="searchValue"
          placeholder="请输入搜索内容"
          class="input-with-select"
          @keyup.enter.native="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-table :data="consults" tooltip-effect="dark" @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center"></el-table-column>
      <!-- 当内容过长被隐藏时显示 tooltip -->
      <el-table-column prop="username" label="用户邮箱" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="goods_list" align="center" label="商品">
        <template slot-scope="scope">
          <div class="cover-name" style="display: flex;align-items: center;justify-content: center;" v-if="scope.row.goods_list">

  
            <img class="good-img" style="width: 50px;height: 50px; display: inline-block;object-fit: cover;" v-for="src in scope.row.goods_list.slice(0, 9).map(good=>good.cover)" :src="`${baseURL}/${src}?q=30`" />
            
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user_message_unread" align="center" label="未读消息数">
        <template slot-scope="scope">
            <i :class="scope.row.user_message_unread?'alert':'normal'">{{scope.row.user_message_unread}}</i>
        </template>
      </el-table-column>
      <el-table-column prop="last_message" align="center" label="最后一条消息">
        <template slot-scope="scope">
            <i>{{scope.row.last_user_message.length?scope.row.last_user_message:scope.row.last_admin_message}}</i>
        </template>
      </el-table-column>
      <!-- 能否用:prop的method(add_time)格式化 -->
      <el-table-column prop="create_time_str" align="center" label="创建时间"></el-table-column>
      <!-- <el-table-column prop="update_time_str" align="center" label="最后修改时间"></el-table-column> -->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="checkMessage(scope.row)" icon="el-icon-edit" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[2, 4, 8, 16]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalcount"
      class="pagination"
    ></el-pagination>


    <el-dialog
            :visible.sync="consultMsgShow"
            :before-close="handleDialogClose"
            :show-close="true"
            :destroy-on-close="true"
            append-to-body>
    
            <consult-pannel  :consult="reply_consult"></consult-pannel>  
         
      </el-dialog>
  </div>
</template>

<script>
import { baseURL, consult_list, edit_goods } from '../api/api';
import { getYMDHMS } from '../utils';
import ConsultPannel from '../components/consultpannel/index.vue'
export default {
  name:'ConsultList',
  components:{
    ConsultPannel
  },
  data() {
    return {
      consultMsgShow:false,

      baseURL,
      state:true,
      // 表格数据
      // 批量删除商品的id
      ids: [],
  
      // 搜索框的值
      searchValue: "",
      // 分页器当前页
      currentPage: 1,
      // 每页的商品数
      pageSize: 16,
      // 总商品数
      totalcount: 0,
      consults:[],
      reply_consult:{}
    };
  },

  methods: {
    handleDialogClose(){
      this.consultMsgShow = false
    },
  
    async get_all_consults(){

      const result = await consult_list({
        page:this.currentPage,
        limit:this.pageSize
      })

      this.consults =result.list
      this.totalcount = result.total

      this.timeformat()
      

    },
    // 搜索
    handleSearch() {
      // 根据搜索值获取商品
      this.get_all_consults();
    },
    handleSelectionChange(val) {
      // val为选择的行
      var ids = val.map(v => v.id);
      this.ids = ids;
    },
    // 每页条数改变的时候
    handleSizeChange(val) {
      // 重新改变每页条数
      this.pageSize = val;
      // 并重新获取数据
      this.get_all_consults();
    },
    // 当前页改变的时候
    handleCurrentChange(val) {
      // 修改当前页
      this.currentPage = val;
      // 并重新获取数据
      this.get_all_consults();
    },
    timeformat(){
      this.consults.forEach(consult => {
        consult.create_time_str = getYMDHMS(consult.create_time*1000)
      });
    },
    switch_change(e){
      //ui bug待解决-state_bool变化无反应
      console.log('switch_change',e)
      e.state = e.state_bool == true?1:2
      //update_state.
      edit_goods(e)
      .catch(err=>{
        e.state_bool = !e.state_bool
        this.$message({
          showClose: true,
          message: err,
          type:"error"
        })
      })
    },
    checkMessage(consult){
      this.reply_consult = consult
      this.consultMsgShow = true
      this.$forceUpdate()
    },
  },
  mounted() {
    //   页面加载成功后获取商品列表
    this.get_all_consults();
  }
};
</script>

<style lang="less" scoped>
.tool-tips {
  margin: 20px 0;

  .input-with-select {
    width: 50%;
  }
}
.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.cover-name{
  height: 100%;
}
.good-img {
  width: 60px;
  padding: 0 10px;
}

.good-name{
  font-weight: bold;
  font-size: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制行数为2 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.good-id{
  font-size: 12px;
  color:rgb(135, 140, 151);
  text-align: left;
}

.pagination {
  margin-top: 20px;
}
.alert{
  color: red;
  font-size: 20px;
}
.normal{
  color: lightgray;
}
</style>